/*
 * Copyright (c) Dito Technologies LLC
 */

import {graphql} from "babel-plugin-relay/macro";

export default graphql`
    query PollPlayStepsQuery($piece_id: ID!) {
        music_viewer {
            piece(id: $piece_id) {
                id
                status
            }
        }
    }
`;
